import { MutableRefObject, useEffect } from 'react';

const useClickOutside = (ref: MutableRefObject<HTMLElement | null>, onClickOutside: () => void) => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const element = event.target;
      if (ref && ref.current && element instanceof Node && !ref.current.contains(element))
        onClickOutside();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        // Escape
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClickOutside, ref]);
  return ref;
};

export default useClickOutside;
